import {Layout, Anchor, Typography} from 'antd';
import React, {useState} from 'react';
import appColors from '../../style/theme';
import TeamAdvisors from './TeamAdvisors';
import TeamAtri from './TeamAtri';
import TeamC from './TeamC';
import TeamDL from './TeamDL';
import TeamEdu from './TeamEdu';
import TeamEntre from './TeamEntre';
import TeamHP from './TeamHP';
import TeamLeadership from './TeamLeadership';
import TeamWL from './TeamWL';

const {Link} = Anchor;
const {Sider, Content} = Layout;
const Text = Typography;


const handleClick = (e, link) => {
  e.preventDefault();
  console.log(link);
};


const TeamLogic = () => {
  const [backI, setBackI] = useState('transparent');
  const [backII, setBackII] = useState('transparent');
  const [backIII, setBackIII] = useState('transparent');
  const [backIV, setBackIV] = useState('transparent');
  const [backV, setBackV] = useState('transparent');
  const [backVI, setBackVI] = useState('transparent');
  const [backVII, setBackVII] = useState('transparent');
  const [backVIII, setBackVIII] = useState('transparent');
  const [backIX, setBackIX] = useState('transparent');
  const ChangeAnchor = (key) => {
    console.log(key);
    if (key === '#TeamAdvisors') {
      setBackI(appColors['ColorA']);
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamLeadership') {
      setBackI('transparent');
      setBackII(appColors['ColorA']);
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamWL') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII(appColors['ColorA']);
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamDL') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV(appColors['ColorA']);
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamHP') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV(appColors['ColorA']);
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamC') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI(appColors['ColorA']);
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamEdu') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackV('transparent');
      setBackVI('transparent');
      setBackVII(appColors['ColorA']);
      setBackVIII('transparent');
      setBackIX('transparent');
    } else if (key === '#TeamEntre') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII(appColors['ColorA']);
      setBackIX('transparent');
    } else if (key === '#TeamAtri') {
      setBackI('transparent');
      setBackII('transparent');
      setBackIII('transparent');
      setBackIV('transparent');
      setBackVI('transparent');
      setBackVII('transparent');
      setBackVIII('transparent');
      setBackIX(appColors['ColorA']);
    }
  };
  return (
    <Layout style={{background: 'transparent'}}>
      <Sider style={{background: 'transparent'}}>
        <Anchor onClick={handleClick} offsetTop={75} onChange={ChangeAnchor} style={{background: 'transparent'}}>
          <Link href='#TeamAdvisors' title={<Content className='ContentAnchor' style={{borderColor: backI}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Advisors</Text></Content>}/>
          <Link href='#TeamLeadership' title={<Content className='ContentAnchor' style={{borderColor: backII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Leadership</Text></Content>}/>
          <Link href='#TeamWL' title={<Content className='ContentAnchor' style={{borderColor: backIII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Wet Lab</Text></Content>}/>
          <Link href='#TeamDL' title={<Content className='ContentAnchor' style={{borderColor: backIV}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Dry Lab</Text></Content>}/>
          <Link href='#TeamHP' title={<Content className='ContentAnchor' style={{borderColor: backV}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Human Practices</Text></Content>}/>
          <Link href='#TeamC' title={<Content className='ContentAnchor' style={{borderColor: backVI}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Comunication</Text></Content>}/>
          <Link href='#TeamEdu' title={<Content className='ContentAnchor' style={{borderColor: backVII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Education</Text></Content>}/>
          <Link href='#TeamEntre' title={<Content className='ContentAnchor' style={{borderColor: backVIII}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Entrepreneurship</Text></Content>}/>
          <Link href='#TeamAtri' title={<Content className='ContentAnchor' style={{borderColor: backIX}}><Text style={{color: appColors['ColorA'], fontSize: '2.1vh'}}>Attributions</Text></Content>}/>
        </Anchor>
        <p style={{color: appColors['ColorA'], pointerEvents: 'none', fontSize: '2vh', top: '65vh', left: '5vh', textAlign: 'center', position: 'sticky'}}></p>
      </Sider>
      <Layout style={{margin: '1% 1% 0 1%', width: 'fit-content'}}>
        <Layout style={{background: appColors['ColorX'], height: '1px'}} />
        <Layout className='PurpBack' style={{background: appColors['ColorG']}}>
          <Layout style={{margin: '0 0 0 0', background: 'transparent'}}>
            <div id='TeamAdvisors'>
              <TeamAdvisors/>
            </div>
            <div id='TeamLeadership'>
              <TeamLeadership/>
            </div>
            <div id='TeamWL'>
              <TeamWL/>
            </div>
            <div id='TeamDL'>
              <TeamDL/>
            </div>
            <div id='TeamHP'>
              <TeamHP/>
            </div>
            <div id='TeamC'>
              <TeamC/>
            </div>
            <div id='TeamEdu'>
              <TeamEdu/>
            </div>
            <div id='TeamEntre'>
              <TeamEntre/>
            </div>
            <div id='TeamAtri'>
              <TeamAtri/>
            </div>
          </Layout>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default TeamLogic;
